import { permissionManager } from "../PermissionManager/PermissionManager";


export const FIRST_PAGE = 'float-bar-first-page';
export const PREVIOUS_PAGE = 'float-bar-previous-page';
export const GO_TO_PAGE = 'float-bar-go-to-page';
export const NEXT_PAGE = 'float-bar-next-page';
export const LAST_PAGE = 'float-bar-last-page';

export const PREVIOUS_VIEW = 'float-bar-previous-view';
export const NEXT_VIEW = 'float-bar-next-view';

export const ZOOM_IN = 'float-bar-zoom-in';
export const VIEW_SIZE = 'float-bar-view-size';
export const ZOOM_OUT = 'float-bar-zoom-out';

export const ROTATE_LEFT = 'float-bar-rotate-left';
export const ROTATE_RIGHT = 'float-bar-rotate-right';

export const SINGLE_PAGE = 'float-bar-single-page';
export const CONTINUE_PAGE = 'float-bar-continue-page';
export const FACING_PAGE = 'facing-page';
export const CONTINUE_FACING_PAGE = 'continuous-facing-page';
export const FIT_WIDTH = 'float-bar-fit-width'
export const FULL_SCREEN = 'float-bar-full-screen';
export const PIN = 'float-bar-pin'
export const UN_PIN = 'float-bar-un-pin'

export const FLOAT_BAR_BUILD_IN_LIST = [
  // FIRST_PAGE,
  PREVIOUS_PAGE,
  GO_TO_PAGE,
  NEXT_PAGE,
  // LAST_PAGE,
  // PREVIOUS_VIEW,
  // NEXT_VIEW,
  ZOOM_IN,
  VIEW_SIZE,
  ZOOM_OUT,
  // ROTATE_LEFT,
  // ROTATE_RIGHT,
  SINGLE_PAGE,
  CONTINUE_PAGE,
  // FULL_SCREEN,
  FACING_PAGE,
  CONTINUE_FACING_PAGE,
];



// premium features
export const FLOAT_BAR_PREMIUM_BTNS = [
  ROTATE_LEFT,
  ROTATE_RIGHT,
];
permissionManager.registerPremiumFeatures(FLOAT_BAR_PREMIUM_BTNS);